var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67964 10.794C6.05382 7.49085 8.77095 5 12 5C15.2291 5 17.9462 7.49085 18.3204 10.794L18.6652 13.8385C18.7509 14.595 19.0575 15.3069 19.5445 15.88C20.5779 17.0964 19.7392 19 18.1699 19H5.83014C4.26081 19 3.42209 17.0964 4.45549 15.88C4.94246 15.3069 5.24906 14.595 5.33476 13.8385L5.67964 10.794Z",
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21C14.5633 22.1652 13.385 23 12 23C10.615 23 9.43668 22.1652 9 21",
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 1,
    width: 10,
    height: 10,
    rx: 5,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.9837b3d46b3604fb02117b0b8fa94140.svg";
export { ForwardRef as ReactComponent };